"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "HMS 1/2 (80/20)",
  description: "Heavy Melting Steel. Sourced from industrial demolition and heavy machinery.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/3d_isometric_cloud_render.png"
}, {
  title: "Shredded Scrap",
  description: "Magnetically separated steel scrap (ISRI 211). High purity melt yield. Sized for furnace efficiency.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/3d_isometric_ai_brain_render.png"
}, {
  title: "P&S Scrap",
  description: "Plate and Structural steel. Sourced from infrastructure projects. High carbon density.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/3d_isometric_security_shield_render.png"
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222944" id="industrial-materials-we-command" className="bg-background text-foreground relative w-full overflow-hidden py-24 md:py-32">
      {}
      <div className="bg-primary/10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[800px] rounded-full blur-[120px] pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-20">
          <h2 className="text-foreground font-default text-3xl md:text-5xl font-bold tracking-tighter mb-6">
            Industrial Materials We Command
          </h2>
          <p className="text-foreground/80 font-sans text-lg md:text-xl max-w-2xl mx-auto">
            High-volume scrap metal sourcing and global delivery coordination for the world&apos;s leading steel mills and foundries.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
          {features.map((feature, i) => <div key={i} data-index={i} className="group relative rounded-none p-[1px] bg-border transition-all duration-500 hover:bg-primary hover:shadow-4xl hover:shadow-primary/20">
              <Card className="bg-card/60 backdrop-blur-xl border-none h-full rounded-none flex flex-col items-center text-center p-10 transition-colors duration-500 group-hover:bg-card/80">
                <div className="mb-8 relative">
                  <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full scale-0 transition-transform duration-500 group-hover:scale-150" />
                  <img src={feature.icon} alt={feature.title} className="w-24 h-24 object-contain relative z-10 transition-transform duration-500 group-hover:-translate-y-2" />
                </div>
                <h3 className="text-foreground font-default text-2xl font-bold mb-4">
                  {feature.title}
                </h3>
                <p className="text-foreground/70 font-mono text-sm leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}